export default __webpack_public_path__ + "static/media/donacion_otros.64749b83.png";